<template>
  <div class="contacts">
    <div class="contacts-left-side">
      <template v-if="!isSendForm">
        <div class="contacts-form-header">
          <div>Senda fyrirspurn {{carTitleFullModelName}}</div>

<!--          <car-number-or-id :entry-number="entryCarId"></car-number-or-id>-->
        </div>

        <hr class="hr" />

        <form @submit.prevent="validateBeforeSubmit()" class="contacts-form">
          <div class="contacts-form-row">
            <div class="contacts-form-left-col">
              <div class="form-group">
                <div class="field-wrapper">
                  <input
                    id="name"
                    type="text"
                    class="form-control"
                    name="Nafn"
                    v-validate="'required'"
                    v-model="contactFormData.name"
                  />
                  <label
                    :class="[
                      contactFormData.name ? 'filled-label' : 'contacts-label',
                    ]"
                    for="name"
                    >Nafn*</label
                  >
                </div>
                <span v-show="errors.has('Nafn')" class="error">{{
                  errors.first("Nafn")
                }}</span>
              </div>

              <div class="form-group">
                <div class="field-wrapper">
                  <input
                    id="email"
                    type="text"
                    class="form-control"
                    name="Netfang"
                    v-validate="'required|email'"
                    v-model="contactFormData.email"
                    data-vv-validate-on
                  />
                  <label
                    :class="[
                      contactFormData.email ? 'filled-label' : 'contacts-label',
                    ]"
                    for="email"
                    >Netfang*</label
                  >
                </div>
                <span v-show="errors.has('Netfang')" class="error">{{
                  errors.first("Netfang")
                }}</span>
              </div>

              <div class="form-group">
                <div class="field-wrapper fw-w-bot-margin">
                  <input
                    id="phone"
                    type="text"
                    class="form-control"
                    name="Símanúmer"
                    v-validate="
                      contactFormData.callback ? 'required|numeric' : ''
                    "
                    v-model="contactFormData.phoneNumber"
                  />
                  <label
                    :class="[
                      contactFormData.phoneNumber
                        ? 'filled-label'
                        : 'contacts-label',
                    ]"
                    for="phone"
                  >
                    Símanúmer{{ contactFormData.callback ? "*" : "" }}
                  </label>
                </div>
                <span v-show="errors.has('Símanúmer')" class="error">{{
                  errors.first("Símanúmer")
                }}</span>
              </div>

              <label
                for="checkbox-callback"
                :class="{ 'checked-label': contactFormData.callback }"
                class="checkbox-filter-label"
              >
                <input
                  type="checkbox"
                  name="callback"
                  id="checkbox-callback"
                  v-model="contactFormData.callback"
                />
                <span class="checkmark"></span>
                <span class="checkbox-text">Ég vil panta símtal</span>
              </label>

              <label
                for="checkbox-testdrive"
                :class="{ 'checked-label': contactFormData.testdrive }"
                class="checkbox-filter-label"
              >
                <input
                  type="checkbox"
                  name="testdrive"
                  id="checkbox-testdrive"
                  v-model="contactFormData.testdrive"
                />
                <span class="checkmark"></span>
                <span class="checkbox-text">Óska eftir reynsluakstri</span>
              </label>
            </div>
            <div class="contacts-form-right-col">
              <img class="contacts-img" :src="car.thumbnail || carImage" />
            </div>
          </div>

          <div
            v-if="contactFormData.testdrive"
            class="contacts-form-hiden-wrapper"
          >
            <div class="form-group">
              <div class="field-wrapper" style="padding-top: 3px">
                <date-picker
                  v-model="contactFormData.driveday"
                  name="driveday"
                  :lang="lang"
                  format="YYYY-MM-DD"
                  value-type="format"
                  placeholder="Veldu dag"
                  class="form-control"
                  :not-before="disabledDates"
                  :open-date="new Date()"
                  style="padding-right: 55px"
                >
                  <div slot="calendar-icon"></div>
                </date-picker>
                <calendar-icon></calendar-icon>
              </div>
              <div v-if="validDateFlag" class="error">
                The date field is required
              </div>
            </div>
            <div class="form-group">
              <div class="field-wrapper" style="padding-top: 3px">
                <select
                  v-model="contactFormData.drivetime"
                  name="drivetime"
                  class="form-control"
                >
                  <option value="" disabled selected>Veldu tíma</option>
                  <option>Fyrir hádegi</option>
                  <option>Eftir hádegi</option>
                  <option>Síðdegis</option>
                </select>
              </div>
              <!--                        <div class="field-wrapper" style="padding-top: 3px">-->
              <!--                            &lt;!&ndash; <input  type="text"  name="drivetime"  id="drive-time"  class="form-control"  v-model="contactFormData.drivetime"  style="padding-right: 55px"  v-validate="'required'">  <label class="contacts-label" for="drive-time">Veldu tíma</label> &ndash;&gt;-->
              <!--                            <date-picker v-model="contactFormData.drivetime" lang="en" name="drivetime" type="time"-->
              <!--                                         format="HH:mm" :minute-step="1" :confirm="true" placeholder="Veldu tíma"-->
              <!--                                         class="form-control" style="padding-right: 55px">-->
              <!--                                <div slot="calendar-icon"></div>-->
              <!--                            </date-picker>-->
              <!--                                          <clock-icon></clock-icon>-->
              <!--                        </div>-->
              <div v-if="validTimeFlag" class="error">
                The time field is required
              </div>
            </div>
          </div>
          <label
            for="tilbod"
            :class="{ 'checked-label': contactFormData.tilbod }"
            class="checkbox-filter-label"
          >
            <input
              type="checkbox"
              name="tilbod"
              id="tilbod"
              v-model="contactFormData.tilbod"
            />
            <span class="checkmark"></span>
            <span class="checkbox-text">Tilboð í uppítöku</span>
          </label>
          <div
            v-show="contactFormData.tilbod"
            class="contacts-form-hiden-wrapper"
          >
            <div class="form-group">
              <div class="field-wrapper">
                <input
                  type="text"
                  name="car-number"
                  id="car-number"
                  class="form-control"
                  v-model="contactFormData.carnumber"
                />
                <label
                  :class="[
                    contactFormData.carnumber
                      ? 'filled-label'
                      : 'contacts-label',
                  ]"
                  for="car-number"
                >
                  Sláðu inn bílnúmer
                </label>
              </div>
              <!-- <div v-if="error['email']" class="error">{{error['email']}}</div> -->
            </div>
            <div class="form-group">
              <div class="field-wrapper">
                <input
                  type="text"
                  name="car-mileage"
                  id="car-mileage"
                  class="form-control"
                  v-model="contactFormData.mileage"
                />
                <label
                  :class="[
                    contactFormData.mileage ? 'filled-label' : 'contacts-label',
                  ]"
                  for="car-mileage"
                >
                  Hvað er bíllinn ekinn marga km?
                </label>
              </div>
              <!-- <div v-if="error['email']" class="error">{{error['email']}}</div> -->
            </div>
          </div>
          <div class="form-group">
            <div class="field-wrapper fw-w-textarea">
              <textarea
                name="message"
                rows="3"
                class="contacts-textarea"
                id="message"
                v-model="contactFormData.message"
              ></textarea>
              <label
                :class="[
                  contactFormData.message ? 'filled-label' : 'contacts-label',
                ]"
                for="message"
              >
                Fyrirspurn
              </label>
            </div>
            <!-- <div v-if="error['email']" class="error">{{error['email']}}</div> -->
          </div>
          <button class="contacts-send-btn">Senda fyrirspurn</button>
        </form>
      </template>

      <template v-else>
        <ContactFormSuccess :dataCar="car" :brandUrl="brandUrl" />
      </template>
    </div>
    <!-- Right Side -->
    <!-- v-if="car.company.active != 0"   -->
    <CarFormNavBtn v-if="showFormNavBtn && $store.state.isApp" :loaded="$store.getters.carLoaded" class="main-basic-info-btns-wrap-static"/>
    <div v-if="car.company.active != 1" class="contacts-right-side">
      <div class="img-and-btns">
      <img
        v-if="!oldCar"
        :src="getCompanyImg(car.company.logo)"
        alt
        class="contacts-logo"
      />
      <img v-else :src="car.company.logo" alt class="contacts-logo" />
      <company-contacts-btn :company="car.company"/>
      </div>
      <company-contacts :isContactFormBlock="true" :company="car.company" />
    </div>
  </div>
</template>

<script>
import ContactFormSuccess from "@/components/Dealers/ContactFormSuccess";
import DatePicker from "vue2-datepicker";
import CompanyContactsBtn from "./CompanyContactsBtn";
import calendarIcon from "@/components/svg/calendarIcon.vue";
import CompanyContacts from "./CompanyContacts";
import globalNewCar from "../../helpers/globalNewCar";
import CarFormNavBtn from "@/components/Dealers/CarFormNavBtn";
import getBaseUrl from "@/helpers/getBaseUrl";
/*import CarNumberOrId from "./CarNumberOrId";*/

export default {
  components: {
    calendarIcon,
    DatePicker,
    ContactFormSuccess,
    CompanyContacts,
    CompanyContactsBtn,
    CarFormNavBtn
  },
  props: {
    entryCarId: {
      type: Number,
      default: null,
      required: false,
    },
    car: [Array, Object],
    oldCar: {
      type: Boolean,
      default: false,
    },
    brandUrl: {
      type: String,
      default: "",
    }
  },
  data: () => ({
    contactFormData: {
      car_id: "",
      name: "",
      email: "",
      phoneNumber: "",
      testdrive: false,
      callback: false,
      message: "",
      mileage: "",
      carnumber: "",
      tilbod: false,
      drivetime: "",
      driveday: "",
    },
    DatePickerFormat: "dd/MM/yyyy",
    disabledDates: new Date(Date.now() - 8640000),
    lang: {
      days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      pickers: [
        "next 7 days",
        "next 30 days",
        "previous 7 days",
        "previous 30 days",
      ],
      placeholder: {
        dateRange: "Select Date Range",
      },
    },
    validDateFlag: false,
    validTimeFlag: false,
    isSendForm: false,
    showPhoneNum: false,
  }),
  methods: {
    getCompanyImg(i) {
      return globalNewCar.getCompanyImg(i);
    },
    validateBeforeSubmit() {
      let validDate = this.contactFormData.driveday.length > 0; //this.contactFormData.driveday > new Date();
      let validTime = this.contactFormData.drivetime !== "";

      if (this.contactFormData.testdrive) {
        this.validDateFlag = !validDate;
        this.validTimeFlag = !validTime;
      }
      this.$validator
        .validateAll()
        .then((result) => {
          if (this.contactFormData.testdrive) {
            if (!validDate || !validTime) return;
          }

          if (result) {
            this.sendForm();
            return;
          }
        })
        .catch(function () {
          alert("Send not success");
        });
    },
    sendForm() {
      if (this.oldCar) {
        this.contactFormData.old_car = true;
      }
      this.$http
        .post(
          `${this.$store.state.api}/new-cars/send-company-email`,
          this.contactFormData
        )
        .then(function (response) {
          if (response.status === 200) {
            this.isSendForm = true;
            this.$emit("formSubmitted");
            // this.responseForm(response);
            document.querySelector(".contacts-form").reset();
          }
        })
        .catch(function () {});
    },
    call() {
      this.showPhoneNum = !this.showPhoneNum;
      this.$http.post(`${this.$store.state.api}/new-cars/save-stat`, {
        key: "call",
        id: this.car.id,
      });
    },
    webSite() {
      return this.$store.state.viewSiteLink + this.car.id;
    },
    responseForm: function (data) {
      alert(data.status);
    },
  },
  mounted() {
    this.contactFormData.car_id = this.car.id;
  },
  watch: {
    "$store.state.selectedContactFormCheckbox": function (newVal) {
      if (newVal === "phone") {
        this.contactFormData.callback = true;
      }
      if (newVal === "email") {
        this.contactFormData.tilbod = true;
      }
      this.$store.state.selectedContactFormCheckbox = null;
    },
  },
  computed: {
    carTitleFullModelName(){
      const car = this.car;
      if(this.oldCar){
        return `${car.brand} ${car.model}`;
      }
      return `${car.brand} ${car.model_class || ''} ${car.package_name || ''}`;
    },
    carImage() {
      return "/img/main-thumb.png";
    },
    showFormNavBtn() {
      return ["CarInStock", "Car", "DealerCar"].includes(this.$route.name);
    },
  },
};
</script>
